import { generatePath, useNavigate } from 'react-router-dom';
import { paths } from 'src/router/paths';
import { useFeatureFlag } from '../useFeatureFlag';
import { UseNoSearchResultsProps } from './useNoSearchResults.types';

const useNoSearchResults = ({ lang, membership }: UseNoSearchResultsProps) => {
  const navigate = useNavigate();
  const enableRedirectToPageNoSearchResults = useFeatureFlag(
    'enable_redirect_to_page_no_search_results'
  );

  const enableRedirect = lang && membership && enableRedirectToPageNoSearchResults;

  if (!enableRedirect) {
    return;
  }

  const path = generatePath(paths.COMMUNITIES_PATH, {
    lang,
    membership
  });

  return (searchTerm?: string) => navigate(`${path}?q=${searchTerm}`);
};

export default useNoSearchResults;
